import {FinishChildcareFlow} from '../flow'

export const Confirm = () => <FinishChildcareFlow />
